export type LaunchSignupTab =
  | "launch_review"
  | "launch_invoiced"
  | "launch_paid"
  | "launch_total"
  | "launch_cancelled";

type LaunchSignupTabRow = {
  status: string;
  is_test: boolean;
};

const paidStatuses = new Set([
  "payment_received",
  "activation_pending",
  "active",
]);
const excludedStatuses = new Set(["duplicate", "cancelled"]);

export function isLaunchSignupTab(value: string): value is LaunchSignupTab {
  return value === "launch_review" || value === "launch_invoiced" ||
    value === "launch_paid" || value === "launch_total" ||
    value === "launch_cancelled";
}

export function matchesLaunchSignupTab(
  signup: Pick<LaunchSignupTabRow, "status"> & Partial<Pick<LaunchSignupTabRow, "is_test">>,
  tab: LaunchSignupTab,
) {
  if (tab === "launch_cancelled") return signup.status === "cancelled";
  if (signup.is_test || excludedStatuses.has(signup.status)) return false;

  const isPaid = paidStatuses.has(signup.status);
  const isInvoiced = signup.status === "awaiting_payment";
  if (tab === "launch_review") return !isPaid && !isInvoiced;
  if (tab === "launch_invoiced") return isInvoiced;
  if (tab === "launch_paid") return isPaid;
  return true;
}

export function launchSignupTabCounts(
  signups: LaunchSignupTabRow[],
): Record<LaunchSignupTab, number> {
  const review =
    signups.filter((signup) => matchesLaunchSignupTab(signup, "launch_review"))
      .length;
  const invoiced =
    signups.filter((signup) =>
      matchesLaunchSignupTab(signup, "launch_invoiced")
    ).length;
  const paid =
    signups.filter((signup) => matchesLaunchSignupTab(signup, "launch_paid"))
      .length;
  const cancelled =
    signups.filter((signup) =>
      matchesLaunchSignupTab(signup, "launch_cancelled")
    ).length;

  return {
    launch_review: review,
    launch_invoiced: invoiced,
    launch_paid: paid,
    launch_total: review + invoiced + paid,
    launch_cancelled: cancelled,
  };
}
